import { useEffect } from 'react';

import { PORTFOLIO_ORIGIN, setPortfolioOrigin } from '../../utils/navigationCacheUtils';

import { useAuth } from '../../components/AuthProvider';
import PropertiesListPage from '../../containers/PropertiesListPage';
import { ZRAMPropertiesPage } from '../../containers/ZRAMPropertiesPage';

const PropertiesRoute = () => {
  const auth = useAuth();
  const isLoading = 'isPending' in auth && auth.isPending;

  // Recorded here, not in a container: this route has two of them and all link into detail routes.
  useEffect(() => setPortfolioOrigin(PORTFOLIO_ORIGIN.properties), []);

  if (isLoading) {
    // Return null to avoid rendering an unknown page until the data is loaded.
    return null;
  }

  if (auth.user?.isEnterpriseCustomer) {
    return <ZRAMPropertiesPage />;
  }

  return <PropertiesListPage />;
};

export default PropertiesRoute;
